/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{create as o}from"../../../../../core/libs/gl-matrix-2/factories/vec3f64.js";class s{constructor(){this.position0=o(),this.position1=o(),this.faceNormal0=o(),this.faceNormal1=o(),this.componentIndex=0,this.cosAngle=0}}export{s as Edge};
